import { Badge, Button, LegacyCard, IndexTable, LegacyStack, Text } from '@shopify/polaris';
import { useEffect, useState } from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import Loading from '../Common/Loading';

const ProductsWrapperBarcode = ({ data, onDestroy, loadPage }) => {
  const [stock, setStock] = useState([]);
  const [metadata, setMetadata] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  console.log(data);
  const addStock = (variant, qty) => {
    return {
      image: variant.images.length > 0 ? variant.images[0] : null,
      title: variant.title,
      family: variant.family,
      barcode: variant.barcode ?? null,
      size: variant.option ?? null,
      sku: variant.sku ?? null,
      qty,
      createdAt: variant.createdAt,
    };
  };

  useEffect(() => {
    setIsLoading(false);
    if (!data) return;

    if (data.update) setStock([...data.data.filter((d) => d.barcode).map((d) => addStock(d, d.qty)), ...stock]);
    else {
      setStock([...stock, ...data.data.filter((d) => d.barcode).map((d) => addStock(d, d.qty))]);
      setMetadata({ page: 1 });
    }

    //eslint-disable-next-line
  }, [data]);

  const handleVisibilitySensor = (isVisible) => {
    if (isVisible && !isLoading && metadata.next) {
      setIsLoading(true);
      loadPage(metadata.page + 1);
    }
  };

  return (
    <div className="mt-4">
      {stock.length && (
        <LegacyCard>
          <LegacyCard.Section>
            <IndexTable
              selectable={false}
              itemCount={stock.length}
              headings={[
                { title: '' },
                { title: 'Producto' },
                { title: 'Talla' },
                { title: 'Cantidad' },
                { title: 'Acciones' },
              ]}
            >
              {stock.map((row, index) => (
                <IndexTable.Row key={index}>
                  <IndexTable.Cell>
                    <img src={row.image} alt={row.title} className="w-[50px] h-[50px]" />
                  </IndexTable.Cell>
                  <IndexTable.Cell>
                    <LegacyStack vertical>
                      <Text fontWeight="bold">{row.title}</Text>
                      <LegacyStack horizontal>
                        <Badge>{row.barcode}</Badge>
                        <Badge>{row.sku}</Badge>
                      </LegacyStack>
                    </LegacyStack>
                  </IndexTable.Cell>
                  <IndexTable.Cell align="center">
                    <Text variant="headingXl" as="h1">
                      {row.size}
                    </Text>
                  </IndexTable.Cell>
                  <IndexTable.Cell>
                    <Text variant="headingXl" as="h1">
                      {row.qty}
                    </Text>
                  </IndexTable.Cell>
                  <IndexTable.Cell>
                    <Button
                      onClick={() =>
                        onDestroy({
                          barcode: row.barcode,
                          qty: -1,
                        })
                      }
                      destructive
                    >
                      Borrar
                    </Button>
                  </IndexTable.Cell>
                </IndexTable.Row>
              ))}
            </IndexTable>
          </LegacyCard.Section>
        </LegacyCard>
      )}
      {metadata && metadata.next && metadata.page && (
        <VisibilitySensor onChange={handleVisibilitySensor}>
          <Loading />
        </VisibilitySensor>
      )}
    </div>
  );
};

export default ProductsWrapperBarcode;
